import { showApiErrorSnackbar } from '@/shared/helpers/thunk';
import { findPackingListItemByKey, findPackingListItemByMessage } from './helpers';
import { StickerState } from '@/shared/models';
import { baseApi } from '@/warehouse/baseApi';
import { t } from '@/core/localization';
import { providesList } from '@/shared/helpers/api';
import { getCrossdockIdFromStorage } from '@/warehouse/helpers/getCrossdockIdFromStorage';
import { createCrossdockingHubCacheListener } from '@/warehouse/signalR';
import { current } from '@reduxjs/toolkit';
// TODO: later. remove away DeliveryBoxes during refactoring (later if we do not need db).
export const packingApi = baseApi
    .enhanceEndpoints({ addTagTypes: ['Packing', 'PackingDetails', 'DeliveryBoxes'] })
    .injectEndpoints({
    endpoints: (builder) => ({
        getPackingCounterparties: builder.query({
            query: ({ crossDockId }) => `crossdocking/${crossDockId}/picking`,
            providesTags: (result) => providesList(result, 'Packing', 'userId'),
            onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
                try {
                    await queryFulfilled;
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.packing.items.request.failed'), error }));
                }
            },
            // TODO: remove this transform response when backend send new updated view model.
            transformResponse: (returnValue) => {
                return returnValue.map(({ driverId, driverName, driverVehicleNumber, driverSource, ...item }) => ({
                    ...item,
                    driver: driverId
                        ? {
                            driverId,
                            driverName,
                            driverVehicleNumber,
                            driverSource,
                        }
                        : null,
                }));
            },
            /*
        // TODO: to delete
        onCacheEntryAdded: async (arg, { updateCachedData, cacheDataLoaded, cacheEntryRemoved }) => {
            const { addEventListener } = crossdockingHubSignalrConnector();
            const unsubscribes: (() => void)[] = [];

            try {
                // wait for the initial query to resolve before proceeding
                await cacheDataLoaded;

                const stickerPackedEventListener: ConnectionHubListenerEvent<'StickerPicked'> = (message) => {
                    updateCachedData((draft) => {
                        // TODO: to delete
                        // console.log('getPackingItems, onCacheEntryAdded in stickerPackedEventListener, draft:', current(draft));
                        // console.log('getPackingItems, onCacheEntryAdded in stickerPackedEventListener, message:', message);

                        const listItemIndex = draft.findIndex(findPackingListItemByMessage(message));

                        if (listItemIndex === -1) return;

                        draft[listItemIndex].pickedStickersCount++;
                    });
                };

                const stickerPutoutEventListener: ConnectionHubListenerEvent<'StickerPutouted'> = (message) => {
                    updateCachedData((draft) => {
                        // TODO: to delete
                        // console.log('getPackingItems, onCacheEntryAdded in stickerPutoutEventListener, draft:', current(draft));
                        // console.log('getPackingItems, onCacheEntryAdded in stickerPutoutEventListener, message:', message);

                        const listItemIndex = draft.findIndex(findPackingListItemByMessage(message));

                        if (listItemIndex === -1) return;

                        draft[listItemIndex].pickedStickersCount--;
                    });
                };

                const stickerBlockedEventListener: ConnectionHubListenerEvent<'StickerBlocked'> = (message) => {
                    updateCachedData((draft) => {
                        // TODO: to delete
                        // console.log('getPackingItems, onCacheEntryAdded in stickerBlockedEventListener, draft:', current(draft));
                        // console.log('getPackingItems, onCacheEntryAdded in stickerBlockedEventListener, message:', message);
                        //
                        // TODO: to return when Blocking will be added to Packing section.
                        //
                        // const listItemIndex = draft.findIndex(findPackingListItemByMessage(message));
                        // if (listItemIndex === -1) return;
                        // draft[listItemIndex].stickersCount -= message.stickersCount > 0 ? 1 : 0;
                        // draft[listItemIndex].summ -= message.summ > 0 ? message.userPrice : 0;
                    });
                };

                const shipmentCreatedEventListener: ConnectionHubListenerEvent<'ShipmentCreated'> = (message) => {
                    updateCachedData((draft) => {
                        // TODO: to delete
                        // console.log('getPackingDetails, onCacheEntryAdded in realizationCreatedEventListener, draft:', current(draft));
                        // console.log('getPackingDetails, onCacheEntryAdded in realizationCreatedEventListener, message:', message);

                        const listItemIndex = draft.findIndex(findPackingListItemByMessage(message));

                        if (listItemIndex === -1) return;

                        draft[listItemIndex].stickersCount -= message.stickerIds.length;
                        draft[listItemIndex].pickedStickersCount = 0;
                        draft[listItemIndex].summ = message.stickerSumm;
                    });
                };

                unsubscribes.push(
                    addEventListener('StickerPicked', stickerPackedEventListener),
                    addEventListener('StickerPutouted', stickerPutoutEventListener),
                    addEventListener('StickerBlocked', stickerBlockedEventListener),
                    addEventListener('ShipmentCreated', shipmentCreatedEventListener)
                );
            } catch {
                // no-op in case `cacheEntryRemoved` resolves before `cacheDataLoaded`,
                // in which case `cacheDataLoaded` will throw
            }

            // cacheEntryRemoved will resolve when the cache subscription is no longer active.
            await cacheEntryRemoved;

            // Detach this cache entry's listeners, otherwise they pile up on the shared connection.
            unsubscribes.forEach((unsubscribe) => unsubscribe());
        }, */
            onCacheEntryAdded: createCrossdockingHubCacheListener(({ updateCachedData }) => ({
                StickerPicked: (message) => {
                    updateCachedData((draft) => {
                        const listItemIndex = draft.findIndex(findPackingListItemByMessage(message));
                        if (listItemIndex === -1)
                            return;
                        draft[listItemIndex].pickedStickersCount++;
                    });
                },
                StickerPutouted: (message) => {
                    updateCachedData((draft) => {
                        const listItemIndex = draft.findIndex(findPackingListItemByMessage(message));
                        if (listItemIndex === -1)
                            return;
                        draft[listItemIndex].pickedStickersCount--;
                    });
                },
                ShipmentCreated: (message) => {
                    updateCachedData((draft) => {
                        const listItemIndex = draft.findIndex(findPackingListItemByMessage(message));
                        if (listItemIndex === -1)
                            return;
                        draft[listItemIndex].stickersCount -= message.stickerIds.length;
                        draft[listItemIndex].pickedStickersCount = 0;
                        draft[listItemIndex].summ = message.stickerSumm;
                    });
                },
            })),
        }),
        getCustomersForPacking: builder.query({
            query: () => ({
                method: 'GET',
                url: 'picking/users4picking',
                cache: 'no-cache',
            }),
            onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
                try {
                    await queryFulfilled;
                    // dispatch(placementActions.setPlacedItemCount(result.data?.length ?? 0));
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.customers.for.packing.request.failed'), error }));
                }
            },
            // providesTags: (result) => [{ type: 'Cells', id: 'LIST' }],
        }),
        startPacking: builder.mutation({
            query: ({ customerIds }) => ({
                method: 'POST',
                url: 'picking/startPicking4Users',
                body: { userIds: customerIds },
            }),
            onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
                try {
                    const { data } = await queryFulfilled;
                    if (!data.success)
                        dispatch(showApiErrorSnackbar({ header: t('start.packing.for.users.request.failed'), error: 'Unknown error' }));
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('start.packing.for.users.request.failed'), error }));
                }
            },
            // invalidatesTags: (result, error, { stickerId }) => (error ? [] : [{ type: 'Placement', id: stickerId }, { type: 'Cells' }]),
        }),
        getPackingDetails: builder.query({
            query: ({ customerId, legalId }) => ({
                method: 'GET',
                url: `crossdocking/${getCrossdockIdFromStorage()}/picking/stickers`,
                cache: 'no-cache',
                params: { customerId, legalId },
            }),
            providesTags: () => [{ type: 'PackingDetails', id: 'LIST' }],
            onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
                try {
                    await queryFulfilled;
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.packing.details.request.failed'), error }));
                }
            },
            // TODO: to delete
            // onCacheEntryAdded: async (arg, { updateCachedData, cacheDataLoaded, cacheEntryRemoved }) => {
            // 	const { addEventListener } = crossdockingHubSignalrConnector();
            // 	try {
            // 		await cacheDataLoaded;
            // 		const stickerPackedEventListener: ConnectionHubListenerEvent<'StickerPicked'> = (message) => {
            // 			updateCachedData((draft) => {
            // 				// TODO: to delete
            // 				// console.log('getPackingDetails, onCacheEntryAdded in stickerPackedEventListener, draft:', current(draft));
            // 				// console.log('getPackingDetails, onCacheEntryAdded in stickerPackedEventListener, message:', message);
            // 				const stickerIndex = draft.stickers.findIndex((sticker) => sticker.stickerId === message.stickerId);
            // 				if (stickerIndex === -1) return;
            // 				draft.stickers[stickerIndex].state = StickerState.Packed;
            // 				// draft.stickers[stickerIndex].deliveryBoxNumber = message.deliveryBoxNumber;
            // 			});
            // 		};
            // 		const stickerPutoutEventListener: ConnectionHubListenerEvent<'StickerPutouted'> = (message) => {
            // 			updateCachedData((draft) => {
            // 				// TODO: to delete
            // 				// console.log('getPackingDetails, onCacheEntryAdded in stickerPutoutEventListener, draft:', current(draft));
            // 				// console.log('getPackingDetails, onCacheEntryAdded in stickerPutoutEventListener, message:', message);
            // 				const stickerIndex = draft.stickers.findIndex((sticker) => sticker.stickerId === message.stickerId);
            // 				if (stickerIndex === -1) return;
            // 				draft.stickers[stickerIndex].state = StickerState.Receipted;
            // 				// draft.stickers[stickerIndex].deliveryBoxNumber = message.deliveryBoxNumber;
            // 			});
            // 		};
            // 		const stickerBlockedEventListener: ConnectionHubListenerEvent<'StickerBlocked'> = (message) => {
            // 			updateCachedData((draft) => {
            // 				draft.stickers = draft.stickers.filter((sticker) => sticker.stickerId !== message.stickerId);
            // 			});
            // 		};
            // 		const shipmentCreatedEventListener: ConnectionHubListenerEvent<'ShipmentCreated'> = (message) => {
            // 			updateCachedData((draft) => {
            // 				// TODO: to delete
            // 				console.log('getPackingDetails, onCacheEntryAdded in shipmentCreatedEventListener, draft:', current(draft));
            // 				console.log('getPackingDetails, onCacheEntryAdded in shipmentCreatedEventListener, message:', message);
            // 				// SocketMessage:
            // 				// id: number;
            // 				// supplierId: number | null;
            // 				// userId: number;
            // 				// legalId: number;
            // 				// stickerIds: number[];
            // 				// type: PackingType;
            // 				// stickerSumm: number;
            // 				// stickerQuantity: number;
            // 				// deliveryBoxIds: number[];
            // 				// draft.stickers.map(findPackingListItemByMessage(message)).map()
            // 				// draft.deliveryBox = draft.deliveryBox.filter((deliveryBox) => !message.deliveryBoxIds.includes(deliveryBox.id));
            // 				draft.stickers = draft.stickers.filter((sticker) => !message.stickerIds.includes(sticker.stickerId));
            // 			});
            // 		};
            // 		addEventListener('StickerPicked', stickerPackedEventListener);
            // 		addEventListener('StickerPutouted', stickerPutoutEventListener);
            // 		addEventListener('StickerBlocked', stickerBlockedEventListener);
            // 		addEventListener('ShipmentCreated', shipmentCreatedEventListener);
            // 	} catch {
            // 		// no-op in case `cacheEntryRemoved` resolves before `cacheDataLoaded`,
            // 		// in which case `cacheDataLoaded` will throw
            // 	}
            // 	// cacheEntryRemoved will resolve when the cache subscription is no longer active
            // 	await cacheEntryRemoved;
            // },
            onCacheEntryAdded: createCrossdockingHubCacheListener(({ updateCachedData }) => ({
                StickerPicked: (message) => {
                    updateCachedData((draft) => {
                        // TODO: to delete
                        // console.log('getPackingDetails, onCacheEntryAdded in stickerPackedEventListener, draft:', current(draft));
                        // console.log('getPackingDetails, onCacheEntryAdded in stickerPackedEventListener, message:', message);
                        const stickerIndex = draft.stickers.findIndex((sticker) => sticker.stickerId === message.stickerId);
                        if (stickerIndex === -1)
                            return;
                        draft.stickers[stickerIndex].state = StickerState.Packed;
                        // draft.stickers[stickerIndex].deliveryBoxNumber = message.deliveryBoxNumber;
                    });
                },
                StickerPutouted: (message) => {
                    updateCachedData((draft) => {
                        // TODO: to delete
                        // console.log('getPackingDetails, onCacheEntryAdded in stickerPutoutEventListener, draft:', current(draft));
                        // console.log('getPackingDetails, onCacheEntryAdded in stickerPutoutEventListener, message:', message);
                        const stickerIndex = draft.stickers.findIndex((sticker) => sticker.stickerId === message.stickerId);
                        if (stickerIndex === -1)
                            return;
                        draft.stickers[stickerIndex].state = StickerState.Receipted;
                        // draft.stickers[stickerIndex].deliveryBoxNumber = message.deliveryBoxNumber;
                    });
                },
                StickerBlocked: (message) => {
                    updateCachedData((draft) => {
                        draft.stickers = draft.stickers.filter((sticker) => sticker.stickerId !== message.stickerId);
                    });
                },
                ShipmentCreated: (message) => {
                    updateCachedData((draft) => {
                        // TODO: to delete
                        console.log('getPackingDetails, onCacheEntryAdded in shipmentCreatedEventListener, draft:', current(draft));
                        console.log('getPackingDetails, onCacheEntryAdded in shipmentCreatedEventListener, message:', message);
                        // SocketMessage:
                        // id: number;
                        // supplierId: number | null;
                        // userId: number;
                        // legalId: number;
                        // stickerIds: number[];
                        // type: PackingType;
                        // stickerSumm: number;
                        // stickerQuantity: number;
                        // deliveryBoxIds: number[];
                        // draft.stickers.map(findPackingListItemByMessage(message)).map()
                        // draft.deliveryBox = draft.deliveryBox.filter((deliveryBox) => !message.deliveryBoxIds.includes(deliveryBox.id));
                        draft.stickers = draft.stickers.filter((sticker) => !message.stickerIds.includes(sticker.stickerId));
                    });
                },
            })),
        }),
        packSticker: builder.mutation({
            query: ({ stickerId }) => ({
                method: 'POST',
                url: `crossdocking/${getCrossdockIdFromStorage()}/picking/pickup/${stickerId}`,
            }),
            invalidatesTags: (result, error, { stickerId }) => (error ? [] : [{ type: 'PackingDetails', id: stickerId }]),
        }),
        removeAwaySticker: builder.mutation({
            query: ({ stickerId }) => ({
                method: 'POST',
                url: `crossdocking/${getCrossdockIdFromStorage()}/picking/putout/${stickerId}`,
            }),
            onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
                try {
                    await queryFulfilled;
                    // if (!data.success) dispatch(showApiErrorSnackbar({ header: t('unpack.detail.sticker.request.failed'), error: 'Unknown error' }));
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('unpack.detail.sticker.request.failed'), error }));
                }
            },
        }),
        blockSticker: builder.mutation({
            query: ({ stickerId, blockReason }) => ({
                method: 'POST',
                url: `crossdocking/${getCrossdockIdFromStorage()}/sticker/block`,
                body: { stickerId, blocked: true, blockReason },
            }),
            // invalidatesTags: (result, error, { stickerId }) => (error ? [] : [{ type: 'Placement', id: stickerId }]),
            onQueryStarted: async (request, { dispatch, queryFulfilled }) => {
                const { stickerId, customerId, legalId } = request;
                const packingDetailsRequestPayload = {
                    customerId,
                    legalId,
                };
                // Optimistic update.
                const patchResult = dispatch(packingApi.util.updateQueryData('getPackingDetails', packingDetailsRequestPayload, (draft) => {
                    const patch = {
                        ...draft,
                        stickers: draft.stickers.filter((sticker) => sticker.stickerId !== stickerId),
                    };
                    Object.assign(draft, patch);
                }));
                try {
                    await queryFulfilled;
                }
                catch {
                    patchResult.undo();
                    // Alternatively, on failure we can invalidate the corresponding cache tags
                    // to trigger a re-fetch:
                    // dispatch(api.util.invalidateTags(['Post']))
                }
            },
        }),
        // Not used currently // TODO: mb remove
        unblockSticker: builder.mutation({
            query: ({ stickerId }) => ({
                method: 'POST',
                url: `crossdocking/${getCrossdockIdFromStorage()}/sticker/block`,
                body: { stickerId, blocked: false },
            }),
            // invalidatesTags: (result, error, { stickerId }) => (error ? [] : [{ type: 'Placement', id: stickerId }]),
            onQueryStarted: async (request, { dispatch, queryFulfilled }) => {
                const { customerId, legalId } = request;
                const packingDetailsRequestPayload = {
                    customerId,
                    legalId,
                };
                // Optimistic update.
                const patchResult = dispatch(packingApi.util.updateQueryData('getPackingDetails', packingDetailsRequestPayload, (draft) => {
                    const patch = {
                        ...draft,
                        // TODO: add action here
                        // stickers: draft.stickers.filter((sticker) => sticker.stickerId !== stickerId),
                    };
                    Object.assign(draft, patch);
                }));
                try {
                    await queryFulfilled;
                }
                catch {
                    patchResult.undo();
                    // Alternatively, on failure we can invalidate the corresponding cache tags
                    // to trigger a re-fetch:
                    // dispatch(api.util.invalidateTags(['Post']))
                }
            },
        }),
        // TODO: do we need this for later?
        // TODO: to delete later. When all new sockets will have been finally done and tested.
        // saveDeliveryBox: builder.mutation<void, SaveDeliveryBoxRequest>({
        // 	query: ({ packingType, customerId, legalId }) => ({
        // 		method: 'POST',
        // 		url: 'picking/saveDeliveryBox',
        // 		body: { pickingType: packingType, userId: customerId, legalId },
        // 	}),
        // 	onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
        // 		try {
        // 			await queryFulfilled;
        // 			// `result` is returned via socket.
        // 		} catch (error) {
        // 			dispatch(showApiErrorSnackbar({ header: t('save.delivery.box.request.failed'), error }));
        // 		}
        // 	},
        // 	// invalidatesTags: (result, error, { stickerId }) => (error ? [] : [{ type: 'Placement', id: stickerId }, { type: 'Cells' }]),
        // }),
        // TODO: do we need this for later?
        // TODO: to delete later. When all new sockets will have been finally done and tested.
        // deleteDeliveryBox: builder.mutation<void, { boxId: number }>({
        // 	query: ({ boxId }) => ({
        // 		method: 'POST',
        // 		url: 'picking/deleteDeliveryBox',
        // 		params: { boxId },
        // 	}),
        // 	onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
        // 		try {
        // 			await queryFulfilled;
        // 		} catch (error) {
        // 			dispatch(showApiErrorSnackbar({ header: t('delete.delivery.box.request.failed'), error }));
        // 		}
        // 	},
        // 	// invalidatesTags: (result, error, { stickerId }) => (error ? [] : [{ type: 'Placement', id: stickerId }, { type: 'Cells' }]),
        // }),
        createRealization: builder.mutation({
            query: ({ crossDockId, ...body }) => ({
                method: 'POST',
                url: `crossdocking/${getCrossdockIdFromStorage()}/shipment`,
                body: body,
            }),
            // invalidatesTags: (result, error, { stickerId }) => (error ? [] : [{ type: 'Placement', id: stickerId }, { type: 'Cells' }]),
        }),
        getDriverLookup: builder.query({
            query: ({ crossDockId, search }) => ({
                method: 'GET',
                url: `crossdocking/${crossDockId}/driver`,
                ...(search?.trim() && { params: { search: search.trim() } }),
            }),
            onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
                try {
                    await queryFulfilled;
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.drivers.request.failed'), error }));
                }
            },
        }),
        getCustomerDefaultDriver: builder.query({
            query: ({ crossDockId, customerId }) => ({
                method: 'GET',
                url: `crossdocking/${crossDockId}/driver/default/${customerId}`,
            }),
            onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
                try {
                    await queryFulfilled;
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.customer.default.driver.request.failed'), error }));
                }
            },
        }),
        assignDriver: builder.mutation({
            query: ({ crossDockId, customerId, legalId, driver }) => ({
                method: 'PUT',
                url: `crossdocking/${crossDockId}/driver-roster`,
                body: {
                    customerId,
                    legalId,
                    driverId: driver?.driverId ?? null,
                },
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                const { crossDockId, customerId, legalId, driver } = arg;
                // Optimistically patch the cache before the server responds.
                const patchResult = dispatch(packingApi.util.updateQueryData('getPackingCounterparties', { crossDockId }, (draft) => {
                    const listItemIndex = draft.findIndex(findPackingListItemByKey({ legalId, userId: customerId }));
                    if (listItemIndex === -1)
                        return;
                    draft[listItemIndex].driver = driver
                        ? {
                            driverId: driver.driverId,
                            driverName: driver.fullName,
                            driverVehicleNumber: driver.vehicleNumber,
                            driverSource: 'roster',
                        }
                        : driver;
                }));
                try {
                    await queryFulfilled;
                }
                catch {
                    patchResult.undo(); // rollback on failure
                }
            },
        }),
    }),
});
export const { useGetPackingCounterpartiesQuery, useGetCustomersForPackingQuery, useStartPackingMutation, useGetPackingDetailsQuery, useRemoveAwayStickerMutation, useCreateRealizationMutation, } = packingApi;
